import { StoreType, useActions } from '@tock/shared/utils/connect';
import { appPatronProfileSelector } from 'selectors/appSelector';
import {
  patronHasSetUpProfileSelector,
  patronIsLoadingSelector,
  patronProfileImportantDaysSelector,
} from 'selectors/patronSelectors';
import { useMountEffect } from '@tock/hooks';
import { useSelector } from 'react-redux';
import CulinaryTravelLogSection from 'components/profile/CulinaryTravelLogSection';
import ProfileDestinationsSection from 'components/profile/ProfileDestinationsSection';
import ProfileDinerSection from 'components/profile/ProfileDinerSection';
import UpcomingReservationSection from 'components/profile/UpcomingReservationSection';
import WelcomeNewUserSection from 'components/profile/WelcomeNewUserSection';

function mapStateToProps(state: StoreType) {
  return {
    routeDataInitialized:
      state.patron.isPurchaseSummariesInitialized && state.patron.isQuizResultsInitialized,
    isLoading: patronIsLoadingSelector(state),
    patronProfile: appPatronProfileSelector(state),
    importantDates: patronProfileImportantDaysSelector(state),
    patronProfilePlaceDescription: state.app.patronProfilePlace?.description,
    hasSetUpProfile: patronHasSetUpProfileSelector(state),
  };
}

const ProfileOverviewRoute = () => {
  const {
    routeDataInitialized,
    isLoading,
    patronProfile,
    importantDates,
    patronProfilePlaceDescription,
    hasSetUpProfile,
  } = useSelector(mapStateToProps);
  const { actions } = useActions();

  useMountEffect(() => {
    if (!routeDataInitialized) {
      actions.patron.fetchPurchaseSummaries();
      actions.patron.fetchQuizResults();
    }
  });

  if (!patronProfile) {
    return null;
  }

  return (
    <div className="ProfileOverviewRoute ProfileOverview--body">
      <UpcomingReservationSection isLoading={isLoading} />
      {!hasSetUpProfile && <WelcomeNewUserSection />}
      <ProfileDinerSection
        patronProfile={patronProfile}
        importantDates={importantDates}
        isLoading={isLoading}
      />
      <CulinaryTravelLogSection
        isLoading={isLoading}
        patronZip={patronProfile.patron?.zipCode || undefined}
        patronCity={patronProfilePlaceDescription}
      />
      <ProfileDestinationsSection patronProfile={patronProfile} isLoading={isLoading} />
    </div>
  );
};

export default ProfileOverviewRoute;
